import React from 'react';
import BatTay from '../../assets/images/CoGaiM57/BatTayBW.png';
import TroChuyen from '../../assets/images/CoGaiM57/TroChuyenBW.png';
import { language } from '../../Blog';
import Navigation from '../Navigation';
import CoGai from './CoGaiM57';
import Breadcrumb from '../Breadcrumbs';

function CoGaiPhan3() {
    const centerTextStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
    };

    const vietTitle = "Cô Gái M57 (phần 3)";
    const renderVietVersion = () => (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '5vh' }}>
                <Breadcrumb language={language} />
            </div>
	        <div style={centerTextStyle}>
	            <h3 style={{ marginTop: "50px" }}>
	                { vietTitle }
	                <div style={{fontSize: "15px"}}>(Lấy cảm-hứng từ bộ-phim "Tình-khúc Bạch-dương")</div>
	            </h3>
	            <h4 style={{ textAlign: "left" }}>4/6/2018</h4>
	            <p style={{ marginBottom: "1em" }}>
		            Trải-qua bao năm-tháng triền-miên <br />
		            Giờ tôi sống với người vợ-hiền <br />
		            Cùng đứa con-trai 24 tuổi <br />
		            Ở trong 1 ngõ-vắng bình-yên <br />
	            </p>
	            <p style={{ marginBottom: "1em" }}>
		            Một hôm dạo quanh khu phố-cổ <br />
		            Giật-mình gặp-lại người yêu xưa <br />
		            Người con-gái cao M57 <br />
		            Đã 50 mà vẫn say-sưa <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Em giờ đã là một bà-cô <br />
		            Mà vẫn đáng-yêu đến bất-ngờ <br />
		            Nụ-cười em vẫn luôn tỏa-sáng <br />
		            Quyến-rũ tâm-hồn của nhà-thơ <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Cùng em nhớ-lại kỉ-niệm xưa <br />
		            Những kí-ức chẳng thể phai-mờ <br />
		            Từ lần-đầu - nụ-cười tỏa-nắng <br />
		            Đến giờ vẫn nụ-cười mộng-mơ <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Về thăm trường-cũ - chục năm rồi <br />
		            Lại ngồi ghế-đá, em với tôi <br />
		            Già rồi vẫn mời thịt-xiên-nướng <br />
		            Lời hứa năm xưa - thực hiện rồi <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Nhìn em, phảng-phất một nỗi-buồn <br />
		            Hai hàng nước-mắt trực-chờ tuôn <br />
		            Rằng vợ-chồng em không hạnh-phúc <br />
		            Hôn-nhân tẻ-nhạt, thật đáng-buồn <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Chồng em - bạn-thân tôi thuở trước <br />
		            Vợ tôi - bạn-thân em ngày-nào <br />
		            Mới thấy tình-yêu không có lỗi <br />
		            Mà lỗi ở những người bạn-thân <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Giờ gặp-lại em mà thấy tiếc <br />
		            Tiếc cho số-phận đã an-bài <br />
		            Tiếc cho tuổi-trẻ nhiều lầm-lỡ <br />
		            Tiếc-nuối thay những tháng ngày-dài <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Tuổi 50 - biết-bao trách-nhiệm <br />
		            Xã-hội, con-cái đến gia-đình <br />
		            Tình-yêu với em là mãi-mãi <br />
		            Nhưng chẳng-thể đổi-thay chính mình <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Cùng em dạo quanh hồ trò chuyện <br />
		            Nắm chặt đôi bàn-tay âu-yếm <br />
		            Đôi bàn-tay ao-ước năm xưa <br />
		            Đôi bàn-tay chẳng được bao-giờ… <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Bỗng một hôm con tôi thông-báo <br />
		            Chuẩn bị ra-mắt vợ tương-lai <br />
		            Trời-ơi thằng-con tôi đã lớn <br />
		            Đã lo được cuộc-sống ngày mai <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Gặp con-dâu - ôi đẹp bất ngờ <br />
		            Con tôi cứ mê đến ngẩn-ngơ <br />
		            Nụ-cười - ánh mặt-trời soi-rọi <br />
		            Ánh-mắt sáng trong thật ngây-thơ <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Cơ mà trông con bé hơi-thấp <br />
		            Hỏi thì chỉ biết cười ha-ha <br />
		            “Dạ thưa, cháu cao M57” <br />
		            Cha nào con nấy, chuẩn nhà ta <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Rồi đến ngày đi gặp thông-gia <br />
		            Trầu-cau đầy-đủ bước vào nhà <br />
		            Sững-người thấy ông-bà bên đó <br />
		            Chính là vợ-chồng em, mx chx <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Hai đứa thì vẫn cứ nói cười <br />
		            Hai nhà quen nhau, chúng rất vui <br />
		            Rồi chúng đi-chơi mà quên-mất <br />
		            Hôm-nay, ngày “nói-chuyện” thông-gia <br />
		        </p>
				<img
	                src={TroChuyen}
	                alt="TroChuyen"
	                style={{ width: '100%', maxWidth: '500px', height: 'auto', margin: '3vh 0' }}
	            />
	            <p style={{ marginBottom: "1em" }}>
		            Cả 4 chúng-tôi đều bối-rối <br />
		            Vì biết-bao kỉ-niệm năm-xưa <br />
		            Vì tình-cảnh éo-le hiện tại <br />
		            Vì hạnh-phúc bọn-trẻ tương-lai <br />
		        </p>
		        <p style={{ marginBottom: "1em" }}>
		            Tôi với chồng-em cùng tâm-sự <br />
		            Anh-ta chẳng còn bận chuyện xưa <br />
		            Cảm-thông cho hoàn-cảnh hiện-tại <br />
		            Hai nhà cùng hướng tới tương-lai <br />
	            </p>
				<img
	                src={BatTay}
	                alt="BatTay"
	                style={{ width: '100%', maxWidth: '500px', height: 'auto', margin: '3vh 0' }}
	            />
	            <p style={{ marginBottom: "7vh" }}>
		            Trước giờ rước-dâu khuyên thằng-bé <br />
		            Con phải hạnh-phúc, phải trưởng-thành <br />
		            Hoàn-thành giấc-mơ cha ngày-trước <br />
		            Cho giấc-mơ con mãi màu-xanh <br />
				</p>
			</div>
    		<Navigation poemTitle={ vietTitle } />
        </div>
    );

    return (
        <div>
            { language === 'English' ? renderVietVersion() : <CoGai/> }
        </div>
    );
}

export default CoGaiPhan3;
